import { LoadingState } from 'src/app/utilities/state.util';
import { BlueSageSetupFragment } from 'src/generated/graphql.generated';

/**
 * BlueSage provisioning state — K3/K4.
 *
 * Requirement: K3/K4 - the typed credential fields live in feature state, and an
 * empty field is never sent, so "unchanged" can never be mistaken for "erase".
 *
 * The credential fields are deliberately part of state rather than component
 * state, per our NgRx conventions. They hold what the operator has *typed*,
 * which is never what is stored: secrets cannot be read back, so an empty field
 * means "leave unchanged" and is never sent.
 */
export const blueSageSettingsInitialState = {
    status: undefined as BlueSageSetupFragment | undefined,
    loading: LoadingState.INIT as LoadingState,
    saving: false as boolean,

    apiKey: '' as string,
    webhookSigningSecret: '' as string,
    locationId: '' as string,
};

export type BlueSageSettingsState = typeof blueSageSettingsInitialState;
